module.exports = __webpack_public_path__ + "img/couponCome.cf203dbc.png";